import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-card',
  templateUrl: './update-card.component.html',
  styleUrls: ['./update-card.component.scss'],
})
export class UpdateCardComponent implements OnInit {
  @Input('title') cardHeading!: string;
  @Input('description') cardDescription!: string;
  @Input('type') cardType!: string;
  constructor() {}

  ngOnInit(): void {}

  navigate() {
    console.log(this.cardType);
  }
}
